<template>
    <div class="box_stock">
        <img
            class="img_stock"
            :src="thumbnailUrl"
            :alt="altText"
        />
        <p class="subtext_services_light color_orange text_align_right">
            {{ formattedDate }}
        </p>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    thumbnailUrl: {
        type: String,
        required: true,
    },
    date: {
        type: String,
        default: '',
    },
});

const altText = computed(() => props.title);

const formattedDate = computed(() => {
    if (!props.date) return '';

    return new Date(props.date).toLocaleDateString('ru-RU');
});
</script>
